import { defineStore } from 'pinia';
import {
  type userType,
  store,
  router,
  resetRouter,
  routerArrays,
} from '../utils';
import {
  getUserInfo,
  ISafeUser,
  SignInBody,
  userLogin,
  userLogout,
  UserRole,
} from '@/api/user';
import { useMultiTagsStoreHook } from './multiTags';
import { setToken, removeToken } from '@/utils/auth';
import { intersection } from 'lodash-es';

export const useUserStore = defineStore('pure-user', {
  state: (): userType => ({
    // 头像
    avatar: '',
    // 页面级别权限
    roles: [],
    // 按钮级别权限
    permissions: [],
    // 是否勾选了登录页的免登录
    isRemembered: false,
    // 登录页的免登录存储几天，默认7天
    loginDay: 7,
    userInfo: {},
  }),
  getters: {
    isAdmin: state =>
      intersection(state.roles, [UserRole.SuperAdmin, UserRole.Admin]).length >
      0,
  },
  actions: {
    setUser(user: ISafeUser) {
      this.avatar =
        'https://image.cbmexpo.com/Chat25/7b9929f1-d5ca-40a7-89ee-f36e7d257f40.png';
      this.roles = user.roles;
      this.userInfo = user.userInfo;
    },
    /** 登入 */
    async loginByUsername(data: SignInBody) {
      const token = await userLogin(data);
      setToken(token);
      const { data: user } = await getUserInfo();
      this.setUser(user);
    },
    /**
     * 免密登录
     */
    async loginByToken(token: string) {
      setToken(token);
      const { data: user } = await getUserInfo();
      this.setUser(user);
    },
    clearUser() {
      this.roles = [];
      this.permissions = [];
      this.userInfo = {};
    },
    /** 前端登出 */
    logOut() {
      this.clearUser();
      removeToken();
      useMultiTagsStoreHook().handleTags('equal', [...routerArrays]);
      resetRouter();
      userLogout();
      router.push('/login');
    },
  },
});

export function useUserStoreHook() {
  return useUserStore(store);
}
